'use client';

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { LeftOutlined } from '@ant-design/icons';
import { twMerge } from 'tailwind-merge';
import { BG_COLORS, COLORS } from '@/common/constants';
import { useRouter } from 'next/navigation';
import CategoryNewsBlock from '@/components/CategoryNewsBlock';
import PostsSearch from './PostsSearch';

const ChuyenMuc = (props) => {
  const { showcaseWalls, menuActive, text, tag, date } = props;
  const router = useRouter();
  if (!isEmpty(text) || !isEmpty(tag) || !isEmpty(date)) {
    return <PostsSearch {...props} />;
  }
  return (
    <>
      <div className="flex items-center">
        <button className={twMerge('mb-3 min-w-8 rounded mr-2 aspect-square', BG_COLORS.greenLight)} onClick={() => router.back()}>
          <LeftOutlined className="!text-white" />
        </button>
        <h1 className={twMerge('text-2xl font-bold mb-3', COLORS.primary)}>{menuActive?.name ?? ''}</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {showcaseWalls.map((item) => (
          <CategoryNewsBlock
            key={item.slug}
            slug="tin-tuc"
            titlePage={menuActive?.name ?? ''}
            item={item}
            titleColor="text-blue-700"
            itemPerPage={10}
            deviceType={props.deviceType}
          />
        ))}
      </div>
    </>
  );
};

export default ChuyenMuc;
